import { render, staticRenderFns } from "./applicantsDeclare.vue?vue&type=template&id=2c99145e&scoped=true"
import script from "./applicantsDeclare.vue?vue&type=script&lang=js"
export * from "./applicantsDeclare.vue?vue&type=script&lang=js"
import style0 from "./applicantsDeclare.vue?vue&type=style&index=0&id=2c99145e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c99145e",
  null
  
)

export default component.exports